import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="206" height="206" viewBox="0 0 206 206" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M102.592 205.361C159.122 205.361 204.949 159.534 204.949 103.004C204.949 46.4735 159.122 0.646484 102.592 0.646484C46.0613 0.646484 0.234375 46.4735 0.234375 103.004C0.234375 159.534 46.0613 205.361 102.592 205.361Z" stroke="white" strokeWidth="0.25" strokeMiterlimit="10"/>
    </svg>
)
